import { RESET_STATE } from '../../constants/action-types';


export function resetState() {
    return { type: RESET_STATE }
}